import { Home, Building2, Utensils, Bath, ArrowRight } from "lucide-react";
  import { useNavigate } from "react-router-dom";

const About = () => {
const navigate = useNavigate();


  const services = [
    {
      icon: Home,
      title: "House Cleaning",
      description:
        "We provide top-quality house cleaning services to make your home spotless and refreshing.",
    },
    {
      icon: Building2,
      title: "Office Cleaning",
      description:
        "Maintain a clean and healthy workspace with our professional office cleaning solutions.",
    },
    {
      icon: Utensils,
      title: "Kitchen Cleaning",
      description:
        "Our experts ensure your kitchen is hygienic, fresh, and free from grease and grime.",
    },
    {
      icon: Bath,
      title: "Washroom Cleaning",
      description:
        "Deep cleaning for washrooms to keep them sanitized, fresh, and sparkling clean.",
    },
  ];

  return (
    
    <div className="min-vh-95">
      <div className="container py-5">
        {/* Header Section */}
        <div className="row align-items-start gy-4">
          <div className="col-lg-6">
            <div className="d-flex align-items-center mb-3">
              <span className="text-primary fw-semibold me-2">Our Services</span>
              <div
                style={{ height: "2px", width: "50px", background: "linear-gradient(90deg, #4A90E2, #9013FE)#9013FE" }}
              ></div>
            </div>

            <h1 className="fw-bold mb-4 display-5">
              We're Offering Popular Cleaning Services
            </h1>
          </div>

          <div className="col-lg-6">
            <p className="text-secondary mb-4">
              We believe a clean space is the foundation of comfort and productivity.
              Our team provides reliable and detailed cleaning solutions for homes,
              offices, and commercial properties.
            </p>
            <div className="d-flex gap-1">
              <div
                className="bg-info rounded"
                style={{ width: "30px", height: "4px" }}
              ></div>
              <div
                className="bg-info  opacity-50 rounded"
                style={{ width: "10px", height: "4px" }}
              ></div>
              <div
                className="bg-info  opacity-50 rounded"
                style={{ width: "10px", height: "4px" }}
              ></div>
              <div
                className="bg-info  opacity-50 rounded"
                style={{ width: "10px", height: "4px" }}
              ></div>
            </div>
          </div>
        </div>

        {/* Service Cards */}
        <div className="row mt-5 gy-4">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div className="col-md-6 col-lg-3" key={index}>
                <div className="card h-100 border-0 shadow-sm p-4 text-center service-card">
                  <div className="icon-container d-flex align-items-center justify-content-center mx-auto mb-3">
                    <Icon size={36} color=" #9013FE" className="icon" />
                  </div>
                  <h5 className="fw-bold mb-3 service-title">{service.title}</h5>
                  <p className="text-muted small mb-4 service-text">
                    {service.description}
                  </p>
                  <button
  className="btn btn-link text-dark fw-semibold text-decoration-none d-flex align-items-center justify-content-center gap-2 service-btn"
  onClick={() => navigate("/services-details")}
>
  Read More <ArrowRight size={16} />
</button>

                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* CSS for Animation */}
      <style>
        {`
        
          .service-card {
            position: relative;
            overflow: hidden;
            border-radius: 12px;
            background-color: #fff;
            color: #000;
            transition: all 0.5s ease;
            cursor: pointer;
          }

          /* Background top-to-bottom reveal effect */
          .service-card::before {
            content: "";
            position: absolute;
            top: -100%;
            left: 0;
            width: 100%;
            height: 100%;
            background-color:  #a256accc;
            z-index: 0;
            transition: top 0.5s ease;
          }

          .service-card:hover::before {
            top: 0;
          }

          /* Keep text above background */
          .service-card * {
            position: relative;
            z-index: 1;
            transition: color 0.5s ease;
          }

          .icon-container {
            width: 70px;
            height: 70px;
            border-radius: 10px;
            background-color: rgba(167, 88, 20, 0.1);
            transition: all 0.5s ease;
          }

          .icon {
            transition: all 0.5s ease;
          }

          .service-card:hover {
            transform: translateY(-8px);
          }

          /* On hover */
          .service-card:hover .icon-container {
            background-color: rgba(255, 255, 255, 0.25);
            transform: scale(1.1) rotate(10deg);
          }

          .service-card:hover .icon {
            color: #fff !important;
            transform: rotate(360deg);
          }

          .service-card:hover .service-title,
          .service-card:hover .service-text,
          .service-card:hover .service-btn {
            color: #fff !important;
          }
        `}
      </style>
    </div>
  );
};

export default About;
